//redux
import { useSelector } from "react-redux"

// *************************************************************
//     Misc
export function useControlEscolarDescuentosInscripcion() {
  return useSelector(
    state => state.ControlEscolar.context.descuentosInscripcion
  )
}

export function useControlEscolarDescInscOptions_Inscripcion(elige = false) {
  //
  const today = new Date()

  const options = useControlEscolarDescuentosInscripcion()
  //console.log(options)

  let Options = options
    .filter(
      option =>
        option.Activo === true &&
        option.Display === true &&
        // // Verificamos que la fecha de inicio sea menor a hoy
        // new Date(option.Fecha_Inicio) <= today &&
        // // Y que la fecha final sea mayor a hoy
        // Si Fecha_Final es la cadena "0001-01-01T00:00:00", se ignora la comparación;
        // de lo contrario, se verifica que sea mayor que hoy.
        (option.Fecha_Final === "0001-01-01T00:00:00" ||
          new Date(option.Fecha_Final) > today) &&
        (option.id_Grupo_Servicios === 3 ||
          option.Nombre_Grupo_Servicios === "Inscripción")
    )
    .map(option => {
      return {
        value: option.id_Descuento,
        label: option.Clave_Nombre,
      }
    })

  if (elige) {
    // Agregar una opción "Elige" al inicio del arreglo
    Options.unshift({
      value: -1, // Valor especial para indicar selección predeterminada
      label: "Elige",
    })
  }
  //console.log(Options)
  return Options
}

export function useControlEscolarDescInscOptions_Colegiatura(elige = false) {
  //
  const today = new Date()

  const options = useControlEscolarDescuentosInscripcion()

  let Options = options
    .filter(
      option =>
        option.Activo === true &&
        option.Display === true &&
        // Verificamos que la fecha de inicio sea menor a hoy
        new Date(option.Fecha_Inicio) <= today &&
        // Y que la fecha final sea mayor a hoy
        // Si Fecha_Final es la cadena "0001-01-01T00:00:00", se ignora la comparación;
        // de lo contrario, se verifica que sea mayor que hoy.
        (option.Fecha_Final === "0001-01-01T00:00:00" ||
          new Date(option.Fecha_Final) > today) &&
        (option.id_Grupo_Servicios === 1 ||
          option.Nombre_Grupo_Servicios === "Colegiatura")
    )
    .map(option => {
      return {
        value: option.id_Descuento,
        label: option.Clave_Nombre,
      }
    })

  if (elige) {
    // Agregar una opción "Elige" al inicio del arreglo
    Options.unshift({
      value: -1, // Valor especial para indicar selección predeterminada
      label: "Elige",
    })
  }
  //console.log(Options)
  return Options
}

export function useControlEscolarAlumnos() {
  return useSelector(state => state.ControlEscolar.context.alumnos)
}

export function useControlEscolarError() {
  return useSelector(state => state.ControlEscolar.context.error)
}

export function useControlEscolarIsLoading() {
  return useSelector(state => state.ControlEscolar.context.loading)
}

export function useControlEscolarIsLoadingoPersona() {
  return useSelector(state => state.ControlEscolar.context.loadingoPersona)
}

export function useControlEscolaroDireccion() {
  return useSelector(state => state.ControlEscolar.context.oDireccion)
}

export function useControlEscolaroPersona() {
  return useSelector(state => state.ControlEscolar.context.oPersona)
}

export function useControlEscolaroAlumno() {
  return useSelector(state => state.ControlEscolar.context.oAlumno)
}

export function useControlEscolaroNotificacion() {
  return useSelector(state => state.ControlEscolar.context.notificacion)
}

export function useControlEscolaroPhotoCredencial() {
  return useSelector(state => state.ControlEscolar.context.oPhotoCredencial)
}

export function useControlEscolarsListaIdStatus() {
  return useSelector(state => state.ControlEscolar.context.sListaIdStatus)
}

export function useControlEscolarEmail() {
  return useSelector(state => state.ControlEscolar.context.email)
}

export function useControlEscolarIsLoadingEmail() {
  return useSelector(state => state.ControlEscolar.context.loadingEmail)
}

export function useControlEscolarCurp() {
  return useSelector(state => state.ControlEscolar.context.curp)
}

export function useControlEscolarIsLoadingCurp() {
  return useSelector(state => state.ControlEscolar.context.loadingCurp)
}

export function useControlEscolarMensajeExito() {
  return useSelector(state => state.ControlEscolar.context.mensajeExito)
}
